export default "__VITE_ASSET__V4QrwtFu__"